
import Vue from "vue";
import Api from "@/services/Api";
import { AxiosError, AxiosResponse } from "axios";
import { TableOptions } from "@/models/TableOptions";
import moment from "moment";
import { Snackbar } from "@/lib/Snackbar";
import Swal from "sweetalert2";
import VueMask from "v-mask";
import { Overlay } from "@/lib/Overlay";

Vue.use(VueMask);
export interface IbPessoasColaboraresLog {
  createdAt?: string;
  content?: string;
}
export interface IbPessoasColaboradores {
  id?: number;
  cpf?: string;
  createdAt?: string;
  nome?: string;
  email?: string;
  senha?: string;
  status?: string;
  updatedAt?: string;
}
export interface IbPessoasColaboradoresNovo {
  id?: number;
  cpf?: string;
  createdAt?: string;
  nome?: string;
  email?: string;
  senha?: string;
  status?: string;
  updatedAt?: string;
}
export interface IbPessoasColaboradoresChangePassword {
  newPassword?: string;
}
export interface IbPessoasColaboradoresChangePin {
  newPin?: string;
}
export interface IbPessoasColaboradoresEdit {
  id?: number;
  cpf?: string;
  createdAt?: string;
  nome?: string;
  email?: string;
}
export interface IbPessoasColaboradoresPermissoes {
  id?: number;
  perm_pix_recebidos?: string;
  perm_pix_enviados?: string;
  perm_qrcode_static?: string;
  perm_pix_pendentes?: string;
  perm_extrato?: string;
  perm_saldo?: string;
  perm_rpt_resumo_anual?: string;
  perm_rpt_resumo_mov?: string;
}
export default Vue.extend({
  data() {
    return {
      dialogEditPermissoes: false,
      valid: true,
      isMobile: false,
      dialogNewPassword: false,
      dialogNewPin: false,
      dialogNovoColaborador: false,
      dialogEditColaborador: false,
      userFromChangePassword: 0,
      formNovo: {} as IbPessoasColaboradoresNovo,
      formEdit: {} as IbPessoasColaboradoresEdit,
      formPermissoes: {} as IbPessoasColaboradoresPermissoes,
      formChangePassword: {} as IbPessoasColaboradoresChangePassword,
      formChangePIN: {} as IbPessoasColaboradoresChangePin,
      btnLoading: false,
      userFromChangePermissoes: "",
      errors: [],
      errorsEdit: [],
      nomeNoModal: "",
      lang: navigator.language,
      moment: moment,
      showpass: false,
      search: "",
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      options: {} as TableOptions,
      selectedEntryStatusColaboradores: { id: "TODOS", descricao: "Todos" },
      statusColaboradores: [
        { id: "TODOS", descricao: "Todos" },
        { id: "1", descricao: "Ativos" },
        { id: "2", descricao: "Bloqueados" },
      ],
      headers: [
        { text: "", value: "id", sortable: false },

        { text: "Nome", value: "nome", sortable: true },
        { text: "CPF", value: "cpf", sortable: true },
        { text: "E-mail", value: "email", sortable: true },

        { text: "Telefone", value: "telefone", sortable: true },
      ],
      desserts: new Array<IbPessoasColaboradores>(),
      loadingDesserts: false,
      totalDesserts: 0,
      timeout: 0,
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      defaultStartDate: moment().format("YYYY-MM-DD"),
      defaultEndDate: moment().format("YYYY-MM-DD"),
      maxDate: moment().format("YYYY-MM-DD"),
      dessertsLogs: new Array<IbPessoasColaboraresLog>(),
    };
  },
  created() {
    this.isMobile = this.detectMobile();
    // this.moduloInfo();
  },
  methods: {
    detectMobile() {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },
    doDelayedSearch() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        //this is your existing function
        this.loadDatas();
      }, 1000);
    },
    changePwd(id: number, nome: string) {
      this.nomeNoModal = nome;
      this.userFromChangePassword = id;
      this.dialogNewPassword = true;
    },
    changePin(id: number, nome: string) {
      this.nomeNoModal = nome;
      this.userFromChangePassword = id;
      this.dialogNewPin = true;
    },
    updatePassword() {
      Swal.fire({
        title: "Confirmação",
        text: "Confirma a alteração da senha do colaborador selecionado?",
        icon: "question",
        iconColor: "#F44336",
        showCancelButton: true,
        confirmButtonColor: "#F44336",
        cancelButtonColor: "#757575",
        confirmButtonText: "Alterar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          Api.put(
            "/v2/client/colaboradores/changePwd/" + this.userFromChangePassword,
            this.formChangePassword
          )
            .then((response) => {
              Snackbar.show("Senha do colaborador alterada com sucesso");
              this.loadDatas();
              this.resetPwd();
              this.dialogNewPassword = false;
            })
            .catch((e: AxiosError) => {
              const response = e.response as AxiosResponse;
              const status = response.status;
              const data = response.data;

              if (status == 422) {
                this.errors = data.body.errors;
              } else {
                Swal.fire({
                  text: data.body.error,
                  icon: "error",
                  confirmButtonText: "Ok",
                  showConfirmButton: true,
                  customClass: {
                    confirmButton: "d-block",
                  },
                });
              }
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    },
    updatePin() {
      Swal.fire({
        title: "Confirmação",
        text: "Confirma a alteração do PIN do colaborador selecionado?",
        icon: "question",
        iconColor: "#F44336",
        showCancelButton: true,
        confirmButtonColor: "#F44336",
        cancelButtonColor: "#757575",
        confirmButtonText: "Alterar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          Api.put(
            "/v2/client/colaboradores/changePin/" + this.userFromChangePassword,
            this.formChangePIN
          )
            .then((response) => {
              Snackbar.show("PIN do colaborador alterado com sucesso");
              this.loadDatas();
              this.resetPin();
              this.dialogNewPin = false;
            })
            .catch((e: AxiosError) => {
              const response = e.response as AxiosResponse;
              const status = response.status;
              const data = response.data;

              if (status == 422) {
                this.errors = data.body.errors;
              } else {
                Swal.fire({
                  text: data.body.error,
                  icon: "error",
                  confirmButtonText: "Ok",
                  showConfirmButton: true,
                  customClass: {
                    confirmButton: "d-block",
                  },
                });
              }
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    },
    closeDialogNovoColaborador() {
      this.reset();
      this.dialogNovoColaborador = false;
    },

    edit(item: any) {
      this.formEdit = item;
      this.dialogEditColaborador = true;
    },
    reset() {
      const form = this.$refs.form as HTMLFormElement;
      form.reset();
    },
    resetPwd() {
      const form = this.$refs.formNewPassord as HTMLFormElement;
      form.reset();
    },
    resetPin() {
      const form = this.$refs.formNewPin as HTMLFormElement;
      form.reset();
    },
    closeDialogChangePassword() {
      this.resetPwd();
      this.dialogNewPassword = false;
    },
    closeDialogChangePin() {
      this.resetPin();
      this.dialogNewPin = false;
    },
    showLog(id: number) {
      Overlay.show();
      Api.get("/v2/client/colaboradores/log/" + id, {
        params: {
          startDate: this.startDate,
          endDate: this.endDate,
        },
      })
        .then((response) => {
          console.log(response);
        })
        .catch((error: any) => {
          const response = error.response as AxiosResponse;
          const status = response.status;
          const data = response.data;

          if (status === 422) {
            this.errors = data.body.errors;
          }
          // this.resetRecaptcha();
        })
        .finally(() => {
          Overlay.hide();
        });
    },
    bloquear(id: number) {
      Swal.fire({
        title: "Confirmação",
        text: "Confirma o bloqueio do colaborador selecionado?",
        icon: "question",
        iconColor: "#F44336",
        showCancelButton: true,
        confirmButtonColor: "#F44336",
        cancelButtonColor: "#757575",
        confirmButtonText: "Bloquear",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          Api.put("/v2/client/colaboradores/block/" + id).then((response) => {
            Snackbar.show("Colaborador bloqueado com sucesso");
            this.loadDatas();
          });
        }
      });
    },
    desbloquear(id: number) {
      Swal.fire({
        title: "Confirmação",
        text: "Confirma o desbloqueio do colaborador selecionado?",
        icon: "question",
        iconColor: "#F44336",
        showCancelButton: true,
        confirmButtonColor: "#F44336",
        cancelButtonColor: "#757575",
        confirmButtonText: "Desbloquear",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          Api.put("/v2/client/colaboradores/unblock/" + id).then((response) => {
            Snackbar.show("Colaborador bloqueado com sucesso");
            this.loadDatas();
          });
        }
      });
    },
    loadDatas() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      this.loadingDesserts = true;
      Api.get("/v2/client/colaboradores/index", {
        params: {
          q: this.search,
          page: page,
          limit: itemsPerPage,
          sort: sortBy.toString(),
          desc: sortDesc.toString(),
          status: this.selectedEntryStatusColaboradores.id,
        },
      })
        .then((response) => {
          this.desserts = response.data.body.rows as IbPessoasColaboradores[];
          this.totalDesserts = Number(response.data.body.count.__total);
        })
        .finally(() => {
          this.loadingDesserts = false;
        });
    },
    novoColaborador() {
      this.dialogNovoColaborador = true;
      this.$nextTick(() => {
        this.reset();
      });
    },
    post() {
      this.btnLoading = true;
      this.errors = [];

      Api.post("/v2/client/colaboradores/store", this.formNovo)
        .then((response: AxiosResponse<IbPessoasColaboradores>) => {
          if (response.status == 201) {
            Snackbar.show("Colaborador criado com sucesso!");
            this.loadDatas();
            this.reset();
            this.closeDialogNovoColaborador();
          }
        })
        .catch((e: AxiosError) => {
          const response = e.response as AxiosResponse;
          const status = response.status;
          const data = response.data;

          if (status == 422) {
            this.errors = data.body.errors;
          } else {
            Swal.fire({
              text: data.body.error,
              icon: "error",
              confirmButtonText: "Ok",
              showConfirmButton: true,
              customClass: {
                confirmButton: "d-block",
              },
            });
          }
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    put() {
      this.btnLoading = true;
      this.errorsEdit = [];

      Api.put(
        "/v2/client/colaboradores/update/" + this.formEdit.id,
        this.formEdit
      )
        .then((response: AxiosResponse<IbPessoasColaboradores>) => {
          if (response.status == 200) {
            Snackbar.show("Colaborador alterado com sucesso!");
            this.loadDatas();

            this.dialogEditColaborador = false;
          }
        })
        .catch((e: AxiosError) => {
          const response = e.response as AxiosResponse;
          const status = response.status;
          const data = response.data;

          if (status == 422) {
            this.errors = data.body.errors;
          } else {
            Swal.fire({
              text: data.body.error,
              icon: "error",
              confirmButtonText: "Ok",
              showConfirmButton: true,
              customClass: {
                confirmButton: "d-block",
              },
            });
          }
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    putPermissoes() {
      this.btnLoading = true;
      this.errorsEdit = [];
      Overlay.show();
      Api.put("/v2/client/colaboradores/permissoes/update", this.formPermissoes)
        .then((response: AxiosResponse<IbPessoasColaboradoresPermissoes>) => {
          if (response.status == 200) {
            Snackbar.show("Permissões modificadas com sucesso!");
            // this.loadDatas();

            this.dialogEditPermissoes = false;
          }
        })
        .catch((e: AxiosError) => {
          const response = e.response as AxiosResponse;
          const status = response.status;
          const data = response.data;

          if (status == 422) {
            this.errors = data.body.errors;
          } else {
            Swal.fire({
              text: data.body.error,
              icon: "error",
              confirmButtonText: "Ok",
              showConfirmButton: true,
              customClass: {
                confirmButton: "d-block",
              },
            });
          }
        })
        .finally(() => {
          Overlay.hide();
          this.btnLoading = false;
        });
    },
    permissoes(id: number, nome: string) {
      Overlay.show();
      Api.get("/v2/client/colaboradores/permissoes/show/" + id, {})
        .then((response) => {
          this.formPermissoes = response.data.body;
          this.$nextTick(() => {
            this.userFromChangePermissoes = nome;
            this.dialogEditPermissoes = true;
          });
        })
        .finally(() => {
          Overlay.hide();
        });
    },
    rowClasses(item: any) {
      const ToDate = new Date();
      if (item.status === "1") {
        return "";
      }
      if (item.status === "2") {
        return "error--text";
      }
    },
    confirmRemove(id: number) {
      // Use sweetalert2
      Swal.fire({
        title: "Confirmação",
        text: "Confirma a exclusão do colaborador selecionado?",
        icon: "question",
        iconColor: "#F44336",
        showCancelButton: true,
        confirmButtonColor: "#F44336",
        cancelButtonColor: "#757575",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          Api.delete("/v2/client/colaboradores/destroy/" + id).then(
            (response) => {
              Snackbar.show("Colaborador removido com sucesso");
              this.loadDatas();
            }
          );
        }
      });
    },
  },
  watch: {
    options: {
      handler() {
        this.loadDatas();
      },
    },
    search: {
      handler() {
        this.doDelayedSearch();
      },
    },
  },
});
